export interface State {
    categorySubline: {
        [key: string]: string[];
    };
}

export const initialState: State = {
    categorySubline: {},
};
